/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { CreateSchedule } from '../models/CreateSchedule';
import type { GetScheduleResponse } from '../models/GetScheduleResponse';
import type { IsoDate } from '../models/IsoDate';
import type { RedoScheduleResponse } from '../models/RedoScheduleResponse';
import type { ScheduleExecutionDatesResponse } from '../models/ScheduleExecutionDatesResponse';
import type { UpdateSchedule } from '../models/UpdateSchedule';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class SchedulesForOpenOrdersService {

    /**
     * Creates a new schedule
     * Creates a new schedule for automatic order creation from address book template
     * @returns GetScheduleResponse Response w/ full schedule detail
     * @throws ApiError
     */
    public static postPublicOrdersSchedules({
        requestBody,
    }: {
        requestBody: (CreateSchedule & Record<string, any>)
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postPublicOrdersSchedules({
        requestBody,
    }: {
        requestBody: (CreateSchedule & Record<string, any>)
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetScheduleResponse>;
    public static postPublicOrdersSchedules({
        requestBody
    }: {
        requestBody: (CreateSchedule & Record<string, any>),
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/orders/schedules',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Resolve execution dates for schedule
     * Resolves execution dates for schedule before it's created
     * @returns ScheduleExecutionDatesResponse Response w/ schedule execution dates
     * @throws ApiError
     */
    public static getPublicOrdersSchedulesExecutionDates({
        templateType,
        nextCreationDate,
        offsetDays,
    }: {
        /**
         * Template type
         */
        templateType?: 'TRANSFER' | 'DIRECT_DEBIT' | 'TRANSFER_BULK' | 'DIRECT_DEBIT_BULK',
        /**
         * Next creation date
         */
        nextCreationDate?: IsoDate,
        /**
         * Offset days
         */
        offsetDays?: number
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicOrdersSchedulesExecutionDates({
        templateType,
        nextCreationDate,
        offsetDays,
    }: {
        /**
         * Template type
         */
        templateType?: 'TRANSFER' | 'DIRECT_DEBIT' | 'TRANSFER_BULK' | 'DIRECT_DEBIT_BULK',
        /**
         * Next creation date
         */
        nextCreationDate?: IsoDate,
        /**
         * Offset days
         */
        offsetDays?: number
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<ScheduleExecutionDatesResponse>;
    public static getPublicOrdersSchedulesExecutionDates({
        templateType,
        nextCreationDate,
        offsetDays
    }: {
        /**
         * Template type
         */
        templateType?: 'TRANSFER' | 'DIRECT_DEBIT' | 'TRANSFER_BULK' | 'DIRECT_DEBIT_BULK',
        /**
         * Next creation date
         */
        nextCreationDate?: IsoDate,
        /**
         * Offset days
         */
        offsetDays?: number,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/orders/schedules/execution-dates',
            query: {
                'templateType': templateType,
                'nextCreationDate': nextCreationDate,
                'offsetDays': offsetDays,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Get schedule detail
     * @returns GetScheduleResponse Response w/ full schedule detail
     * @throws ApiError
     */
    public static getPublicOrdersSchedules({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicOrdersSchedules({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetScheduleResponse>;
    public static getPublicOrdersSchedules({
        scheduleId
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/orders/schedules/{scheduleId}',
            path: {
                'scheduleId': scheduleId,
            },
        });
    }

    /**
     * Edit schedule
     * @returns GetScheduleResponse Response w/ full schedule detail
     * @throws ApiError
     */
    public static putPublicOrdersSchedules({
        scheduleId,
        requestBody,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
        requestBody: UpdateSchedule
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static putPublicOrdersSchedules({
        scheduleId,
        requestBody,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
        requestBody: UpdateSchedule
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetScheduleResponse>;
    public static putPublicOrdersSchedules({
        scheduleId,
        requestBody
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
        requestBody: UpdateSchedule,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'PUT',
            url: '/public/orders/schedules/{scheduleId}',
            path: {
                'scheduleId': scheduleId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete schedule
     * @returns void
     * @throws ApiError
     */
    public static deletePublicOrdersSchedules({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static deletePublicOrdersSchedules({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
    public static deletePublicOrdersSchedules({
        scheduleId
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'DELETE',
            url: '/public/orders/schedules/{scheduleId}',
            path: {
                'scheduleId': scheduleId,
            },
        });
    }

    /**
     * Reinitiate failed schedule execution
     * Immediately tries to create payment order from address book template Works only for templates which have `scheduleInfo.isRedoable=true`
     * @returns RedoScheduleResponse Response w/ from scheduler reinitialized schedule
     * @throws ApiError
     */
    public static postPublicOrdersSchedulesRedo({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static postPublicOrdersSchedulesRedo({
        scheduleId,
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<RedoScheduleResponse>;
    public static postPublicOrdersSchedulesRedo({
        scheduleId
    }: {
        /**
         * Schedule id
         *
         */
        scheduleId: string,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'POST',
            url: '/public/orders/schedules/{scheduleId}/redo',
            path: {
                'scheduleId': scheduleId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

}
